import {
  type Dispatch,
  type RefObject,
  type SetStateAction,
} from 'react';
import type {
  CmarkdowntableCell,
  CmarkdowntablePopoverEntry,
  OpenTablePopoverRowInput,
  TableRowKeyDownInput,
} from './Cmarkdowntable.types';
import { useCmarkdowntablePopoverKeyboard } from './useCmarkdowntablePopoverKeyboard';
import { useCmarkdowntablePopoverOpenRow } from './useCmarkdowntablePopoverOpenRow';

interface UseCmarkdowntablePopoverRowActionsInput {
  activeRowIndex: number | null;
  headerCells: CmarkdowntableCell[];
  activeAnchorRef: RefObject<HTMLDivElement | null>;
  closePopover: () => void;
  restoreRememberedManualRect: () => boolean;
  updatePopoverPosition: () => void;
  setActiveRowIndex: Dispatch<SetStateAction<number | null>>;
  setPopoverEntries: Dispatch<SetStateAction<CmarkdowntablePopoverEntry[] | null>>;
  setPopoverIdValue: Dispatch<SetStateAction<string>>;
}

interface CmarkdowntablePopoverRowActions {
  openPopoverForRow: (input: OpenTablePopoverRowInput) => void;
  handleRowKeyDown: (input: TableRowKeyDownInput) => void;
}

export function useCmarkdowntablePopoverRowActions(
  input: UseCmarkdowntablePopoverRowActionsInput,
): CmarkdowntablePopoverRowActions {
  const openPopoverForRow = useCmarkdowntablePopoverOpenRow(input);
  const handleRowKeyDown = useCmarkdowntablePopoverKeyboard({ openPopoverForRow });

  return {
    openPopoverForRow,
    handleRowKeyDown,
  };
}
